import { render, staticRenderFns } from "./StatusExplanationHeader.vue?vue&type=template&id=c06a1508&scoped=true&"
import script from "./StatusExplanationHeader.vue?vue&type=script&lang=ts&"
export * from "./StatusExplanationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StatusExplanationHeader.vue?vue&type=style&index=0&id=c06a1508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06a1508",
  null
  
)

export default component.exports